export default __webpack_public_path__ + "static/media/blog-sealer-003.2b75c913.jpg";